import { z } from 'zod';

const pricingTierSchema = z.object({
    vehicleMin: z.number(),
    vehicleMax: z.number(),
    percentageFee: z.number(),
});
const pricingModelDetailsSchema = z.object({
    fixedPercentageFee: z.number().optional(),
    flatFee: z.number().optional(),
    tiers: z.array(pricingTierSchema).optional(),
    tierResetCadence: z.enum(['annual', 'never']).optional(),
});

export { pricingModelDetailsSchema, pricingTierSchema };
//# sourceMappingURL=PricingModelDetails.js.map
